/**
 * @generated SignedSource<<fe32c5e8456fe4ed0f1d0e7e10e6f365>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutopilotForm_org$data = {
  readonly id: string;
  readonly experiments: ReadonlyArray<string | null> | null;
  readonly nextDefragTime: {
    readonly millis?: any | null;
  } | null;
  readonly suggestedInvites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly targetCalendarId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly pendingInvites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly targetCalendarId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"AutopilotFlexibility_org">;
  readonly " $fragmentType": "AutopilotForm_org";
};
export type AutopilotForm_org$key = {
  readonly " $data"?: AutopilotForm_org$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutopilotForm_org">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetCalendarId",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutopilotForm_org",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AutopilotFlexibility_org"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "experiments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "nextDefragTime",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "millis",
              "storageKey": null
            }
          ],
          "type": "DefragTime",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "SuggestedOrgInviteConnection",
      "kind": "LinkedField",
      "name": "suggestedInvites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SuggestedOrgInviteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SuggestedOrgInvite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "suggestedInvites(first:1000000)"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "OrgInviteConnection",
      "kind": "LinkedField",
      "name": "pendingInvites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgInviteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgInvite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "pendingInvites(first:1000000)"
    }
  ],
  "type": "Org",
  "abstractKey": null
};
})();

(node as any).hash = "7b9ee21ed18a291d0abf47bb2aca0aa0";

export default node;
